<template>
  <div
    v-if="items.length"
    :class="[
      'chart-legend',
      {
        'chart-legend--overflow': showCollapse && hasOverflow,
        'chart-legend--horizontal': direction === 'horizontal',
      },
    ]"
  >
    <div
      ref="legendList"
      :class="[
        'chart-legend__list',
        { 'chart-legend__list--collapsed': showCollapse && hasOverflow && collapsed },
      ]"
      :style="legendListStyle"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="['chart-legend__item', { 'chart-legend__item--inactive': !active[index] }]"
        @click="handleToggle(index, item.name)"
      >
        <span class="chart-legend__icon-wrap">
          <span
            v-if="item.type === 'bar'"
            class="chart-legend__icon chart-legend__icon--bar"
            :style="{ background: active[index] ? item.color : '#ccc' }"
          ></span>
          <span
            v-else-if="item.dashType"
            class="chart-legend__icon chart-legend__icon--dots"
            :style="{ '--dot-color': active[index] ? item.color : '#ccc' }"
          ></span>
          <span
            v-else
            class="chart-legend__icon chart-legend__icon--line"
            :style="{ borderColor: active[index] ? item.color : '#ccc' }"
          ></span>
        </span>
        <span class="chart-legend__label">{{ item.name }}</span>
      </div>
    </div>
    <div
      v-if="showCollapse && hasOverflow"
      class="chart-legend__arrow"
      @click="handleToggleCollapse"
    >
      <i
        :class="[
          'crm--chevron_down',
          'chart-legend__arrow-icon',
          { 'chart-legend__arrow-icon--expanded': !collapsed },
        ]"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiagnosisLegendBR',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Array,
      default: () => [],
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    hasOverflow: {
      type: Boolean,
      default: false,
    },
    collapsedHeight: {
      type: Number,
      default: 0,
    },
    showCollapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    legendListStyle() {
      if (this.showCollapse && this.hasOverflow && this.collapsed && this.collapsedHeight) {
        return {
          maxHeight: `${this.collapsedHeight}px`,
        }
      }
      return {}
    },
  },
  methods: {
    handleToggle(index, name) {
      this.$emit('toggle', { index, name })
    },
    handleToggleCollapse() {
      this.$emit('toggle-collapse')
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-legend {
  display: flex;
  align-items: flex-start;
  margin-top: 0;

  .chart-legend__list {
    padding-right: 20px;
  }

  &--horizontal {
    margin-top: 4px;
  }
}

.chart-legend__list {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}

.chart-legend__list--collapsed {
  max-height: 64px;
}

.chart-legend__item {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  padding: 6px 16px;
  border: 4px solid #b3d3ff;
  border-radius: 16px;
  cursor: pointer;
  transition: border-color 0.2s, opacity 0.2s;
}

.chart-legend__item--inactive {
  opacity: 0.4;
}

.chart-legend__icon-wrap {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
}

.chart-legend__icon {
  display: inline-block;
}

.chart-legend__icon--bar {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.chart-legend__icon--line {
  width: 24px;
  height: 0;
  border-color: inherit;
  border-top: 4px solid #0c0c0d;
}

.chart-legend__icon--dots {
  width: 24px;
  height: 12px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--dot-color);
    box-shadow: -8px 0 0 0 var(--dot-color), 8px 0 0 0 var(--dot-color);
  }
}

.chart-legend__label {
  color: #333;
  font-size: 18px;
  font-weight: 700;
  line-height: 32px;
  white-space: normal;
  word-break: break-all;
  overflow-wrap: anywhere;
  flex: 1;
  min-width: 0;
}

.chart-legend__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  margin-top: 12px;
  margin-left: 20px;
  flex-shrink: 0;
}

.chart-legend__arrow-icon {
  color: #8d9099;
  font-size: 24px;
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.chart-legend__arrow-icon--expanded {
  transform: rotate(0deg);
}
</style>
